import React from 'react';
import { motion } from 'framer-motion';
import { BadgeDivider } from './Badge';
export function WatchListen() {
  return <section id="watch" className="relative w-full bg-[var(--vu-navy)] py-20 px-5 overflow-hidden grain" data-id="element-127" data-mp="53m0za5tbore">
      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-128" data-mp="7ddn9hgop95">
        <p className="font-cond uppercase tracking-[0.4em] text-[var(--vu-gold)] text-xs mb-2" data-id="element-129" data-mp="3saekmki7mwkn">
          Backstage Pass
        </p>
        <h2 className="font-display uppercase text-[var(--vu-cream)] text-5xl sm:text-6xl leading-none" data-id="element-130" data-mp="sw2f59mfiwlf">
          Watch &amp; Listen
        </h2>
        <BadgeDivider label="▶" data-id="element-131" data-mp="j3d6emi9jwts" />

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-4 rotate-[1deg]" data-id="element-132" data-mp="j2bw4k92ned4">
          {/* Polaroid / backstage-pass frame */}
          <div className="bg-[var(--vu-cream)] p-4 pb-6 border-2 border-[var(--vu-black)] shadow-[8px_8px_0_0_var(--vu-black)]" data-id="element-133" data-mp="16sxu1ipd3i9e">
            <div className="relative aspect-video overflow-hidden border border-[var(--vu-black)] bg-[var(--vu-black)]" data-id="element-134" data-mp="116qvwm6o5ns2">
              <iframe className="absolute inset-0 h-full w-full" src="https://www.youtube.com/embed/8dNy2r5j7LQ" title="Virtually Unknown — Can't You See live at Twisted Tiki" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-135" data-mp="rf4eu97nguhe" />
            </div>
            <p className="mt-4 font-cond text-xs uppercase tracking-widest text-[var(--vu-black)]/70" data-id="element-136" data-mp="8gic6pwhivbd">
              Can't You See — Live at Twisted Tiki, 6/28/26.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}